import { render, staticRenderFns } from "./RequestInfoCupo.vue?vue&type=template&id=8f1e83de&"
import script from "./RequestInfoCupo.vue?vue&type=script&lang=js&"
export * from "./RequestInfoCupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports